import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { HACK_alignIconWithLabel } from "@privacy/ui";
import type { FC } from "react";
import { ClassificationScoreChip } from "./ClassificationScoreChip";
import { DynamicHistory } from "../dynamicHistory";
import type { Score } from "./schemas";

type Props = {
  scores: Array<Score>;
  rationale?: string | null;
};

export const ClassificationScoresHistoryView: FC<Props> = ({ scores, rationale }) => {
  const { t } = useTranslation();

  if (scores.length === 0 && !rationale) {
    return <DynamicHistory.EmptyValue />;
  }

  return (
    <Stack sx={{ gap: 1.5 }}>
      {scores.length > 0 && (
        <Stack sx={{ gap: 0.75 }}>
          {scores.map(({ propertyKey, value }) => (
            <Stack key={propertyKey} direction="row" sx={{ alignItems: "center", gap: 1 }}>
              <ClassificationScoreChip
                propertyKey={propertyKey}
                value={value}
                ariaLabel={t(`Classification.PropertyKey.${propertyKey}`)}
              />
              <Typography
                sx={{ fontWeight: 600, ...HACK_alignIconWithLabel, fontSize: theme => theme.typography.pxToRem(12) }}
              >
                {t(`Classification.PropertyKey.${propertyKey}`)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
      {rationale ? (
        <Box>
          <Typography
            component="div"
            sx={{
              fontSize: theme => theme.typography.pxToRem(10),
              fontWeight: 600,
              letterSpacing: "0.08em",
              color: theme => theme.palette.text.tertiary,
              textTransform: "uppercase",
              mb: 0.5,
            }}
          >
            {t("Classification.Edit.RationaleLabel")}
          </Typography>
          <Typography
            sx={{
              fontSize: theme => theme.typography.pxToRem(12),
              lineHeight: 1.5,
              color: theme => theme.palette.text.secondary,
              whiteSpace: "pre-wrap",
            }}
          >
            {rationale}
          </Typography>
        </Box>
      ) : null}
    </Stack>
  );
};
